<template>
    <div class="App">
        <div class="App-mainContainer">
            <Header :user="user" />
            <router-view />
        </div>
        <Footer />
        <span
            class="App-burgerMenu f2m-burger-menu"
            @click="toggleMenu"
            @keyDown.enter="toggleMenu"
        />
        <GlobalLoader
            :showGlobalLoader="showGlobalLoader"
        />
        <TransparentGlobalLoader
            :enable="showTransparentGlobalLoader"
            class="loaderContainer"
        />
        <FullScreenModal
            :showModal="showMenu"
            class="App-menu"
            @hideModal="toggleMenu"
        >
            <MobileMenu @hideMenu="toggleMenu" />
        </FullScreenModal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {loadLanguageAsync} from "@/i18n/i18n";
import GlobalLoader from "@/components/common/GlobalLoader";
import {Loader} from "@free2move/vuejs-components";
import FullScreenModal from "@/components/FullScreenModal";
import MobileMenu from "@/components/MobileMenu.vue";
import {GET_PROFILE} from "@/store/action-types";
import Footer from "@/layouts/Footer";
import Header from "@/layouts/Header";

export default {
    components: {
        MobileMenu,
        GlobalLoader,
        TransparentGlobalLoader: Loader,
        FullScreenModal,
        Footer,
        Header
    },
    data(){
        return {
            showMenu: false,
        }
    },
    computed: {
        ...mapState(['showGlobalLoader', 'showTransparentGlobalLoader', 'user']),
    },
    mounted() {
        this.$store.dispatch(GET_PROFILE, { callback: () => {}});
        loadLanguageAsync({
            language: this.$language,
            country: this.$country,
            baseUrl: this.$baseUrl,
        });
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
    }
};
</script>

<style lang="scss" scoped>
.slide-fade-enter-active, .slide-fade-leave-active,
.slide-fade-loader-enter-active, .slide-fade-loader-leave-active,
.hidden {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to,
.slide-fade-loader-enter, .slide-fade-loader-leave-to,
.hidden {
  transform: translateX(50px);
  opacity: 0;
}
.slide-fade-enter-active, .hidden{
  transition-delay: .3s;
}
.slide-fade-loader-leave-active{
  transition-delay: .3s;
}

.App{


  &-whiteSymbol {
    position: absolute;
    top: 0;
    left: 0;
    width: 500px;
    height: 500px;
    @media only screen and (max-width: $f2m-desktop-breakpoint) {
      display: none;
    }
  }

  &-mainContainer{
      background-image: url('./assets/images/background-big.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-color: $f2m-purple-dark;
    min-height: calc(100vh - 180px);
    @media (max-width: $f2m-desktop-breakpoint) {
        min-height: 100vh;
    }
  }

  &-burgerMenu{
    display: none;
    position: absolute;
    top: 28px;
    right: 28px;
    font-size: 41px;
    color: #FFF;
    cursor: pointer;
    z-index: 4;

    @media (max-width: $f2m-desktop-breakpoint) {
      display: block;
    }
  }
  .loaderContainer{
    width: 100%;
    display:flex;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    border-radius: 0;

    .Loader{
      width: 200px;
    }
  }

  &-menu{
    z-index: 10000;
  }
}
.loaderContainer{
  position: fixed;
}

.navbar .navbar-toggler{
  display: none;
}

.bg-rebranding{
  @media (max-width: $f2m-desktop-breakpoint) {
    background-image: $color-f2m-gradient;
  }

}
</style>
